import { WEB_CONTENT_SERVICE_BASE_URL } from "env";
import { ApplicationModeEnum } from "state/ApplicationStateSchema";
import { createCommonHeaders } from "./commonHeaders";
import { ContentArraySchema, ContentTarget, filterContent } from "utils/filterContent";

export async function getContent(
    applicationMode?: ApplicationModeEnum,
    pageName?: string,
    state?: string,
    planCode?: string,
    clubCode?: string
): Promise<ContentTarget> {
    // The content url is typically loaded from root. I.E. "/content/content.json" => GET https://localhost:8281/content/content.json
    // With apps built using gitlab CI/CD and accessed as artifacts; we want the content url to be relative to the artifact.
    // I.E. "content/content.json" =>
    // GET https://aaa-life.gitlab.io/-/applications/aaalife/web/online-application-frontend/-/jobs/5940421849/artifacts/storybook-static/content/content.json
    const url = `${WEB_CONTENT_SERVICE_BASE_URL}/content/content.json`;
    const headers = {
        ...createCommonHeaders(window),
        "Content-Type": "application/json",
    };

    const response = await fetch(url, {
        method: "GET",
        headers,
    });

    if (!response.ok) {
        console.warn(response);
        throw new Error("Failed to get content");
    }

    const kvs = Object.entries({ applicationMode, pageName, state, planCode, clubCode })
        .filter(([_, v]) => !!v)
        .map(([k, v]) => [k, v || ""] as const);
    const searchTags = new Map(kvs);

    const content = await response.json();
    if (process.env.CI === "true") {
        ContentArraySchema.parse(content);
    }
    return filterContent(searchTags, content);
}
